<template>
    <div>
        <div class="d-flex align-items-center ">
            <span class="mr-2 ml-md-3">
                Filter By:
            </span>
            <div class="w-75">
                <v-select
                    v-model="type"
                    :dir="
                        $store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'
                    "
                    :options="[{id: 'day', name: 'Daily'}, {id: 'month', name: 'Monthly'}, {id: 'year', name: 'Yearly'}]"
                    id="type"
                    class="w-100 mb-0 custom-field"
                    :reduce="(val) => val.id"
                    placeholder="Select Type"
                    :label="'name'"
                >
                <template v-slot:option="option">
                    {{ option.name }}
                </template>
                <template #selected-option="{ name }">
                    <div style="display: flex; align-items: baseline">
                        <strong>{{ name }}</strong>
                    </div>
                </template>
                <template #no-options>{{ $t("noMatching") }}</template>
                </v-select>
            </div>
        </div>
        <center v-if="LoadApiTracker">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
        </center>
        <div v-else class="activity-chart">
            <app-echart-gradient-line-vero :optionData="option" />
        </div>
    </div>
</template>

<script>
import AppEchartGradientLineVero from '@core/components/charts/echart/AppEchartGradientLineVero.vue';
import vSelect from "vue-select";
import { mapGetters } from "vuex";
import {
    BSpinner,
} from "bootstrap-vue";
export default {
    components: {
        BSpinner,
        vSelect,
        AppEchartGradientLineVero,
    },
    data() {
        return {
            type: "day"
        }
    },
    watch: {
        type() {
            this.$store.dispatch("adminDashboard/api_tracker", {type: this.type} );
        }
    },
    computed: {
        ...mapGetters({
            ApiTracker: "adminDashboard/ApiTracker",
            LoadApiTracker: "adminDashboard/LoadApiTracker",
        }),
        option() {
            return {
                xAxisData: this.ApiTracker.datetime || [],
                series: [
                    {
                        type: 'line',
                        smooth: true,
                        data: this.ApiTracker.count || [],
                        lineStyle: {
                            color: '#FF4974',
                            width: 3,
                        },
                        itemStyle: {
                            color: '#FF4974',
                        },
                        emphasis: {
                            focus: 'series',
                        },
                        symbol: 'circle',
                        symbolSize: 8,
                    },
                ],
            };
        },
    },
    mounted() {
        console.log("type", this.type);
        
        this.$store.dispatch("adminDashboard/api_tracker");
    },
};
</script>
  
<style scoped>
.activity-chart {
    height: 28rem;
    display: flex;
    background: transparent;
    padding: 16px;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.chart-container {
    width: 70%;

}

.statistics {
width: 30%;
padding-left: 16px;
display: flex;
flex-direction: column;
justify-content: space-around;
}

.stat {
display: flex;
align-items: center;
justify-content: space-between;
}

.stat span {
color: #999;
}

.stat strong {
font-size: 1.2em;
}

.percentage {
background-color: #fad9e7;
color: #8c2750;
padding: 2px 8px;
border-radius: 12px;
font-weight: bold;
font-size: 0.9em;
}
</style>
